"use client";

import AnnouncementBanner from "@/components/announcement-banner";
import BreadcrumbsContainer from "@/components/breadcrumbs-container";
import Footer from "@/components/footer";
import Navbar from "@/components/navbar";
import { isMobileDevice, setGlobalTheme } from "@/utils";
import OnlyClient from "@/utils/OnlyClient";
import { ThemeProvider, useTheme } from "@/utils/ThemeContext";
import { Link } from "@spheron/ui-library";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import Arrow from "@spheron/ui-library/dist/assets/arrow-right-1.svg";
import { ThirdwebProvider } from "thirdweb/react";

const ThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const { theme } = useTheme();

  useEffect(() => {
    setGlobalTheme(theme);
  }, [theme]);

  return <>{children}</>;
};

export default function Template({ children }: { children: React.ReactNode }) {
  const [deviceType, setDeviceType] = useState<"mobile" | "desktop">("desktop");

  useEffect(() => {
    const checkDeviceType = () => {
      // if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent;
      // const width = window.innerWidth;

      // if (isMobileDevice(userAgent) || width < 1024) {
      if (isMobileDevice(userAgent)) {
        setDeviceType("mobile");
      } else {
        setDeviceType("desktop");
      }
      // }
    };

    checkDeviceType();

    window.addEventListener("resize", checkDeviceType);

    return () => {
      window.removeEventListener("resize", checkDeviceType);
    };
  }, []);

  return (
    <>
      <ThirdwebProvider>
        <ThemeProvider>
          <ThemeWrapper>
            <ToastContainer newestOnTop limit={2} />
            <nav className="sticky top-0 z-[99]">
              {/* <AnnouncementBanner
                content={
                  <div className="text-[11px] flex flex-row gap-x-1 items-center">
                    Network maintenance is done. New features and improvements
                    are released!
                    <Link
                      size="small"
                      isBold
                      type="primary"
                      classname="dark:!text-base-link !text-dark-base-link"
                      text="Learn more here"
                      onClick={() => {
                        window.open(
                          "https://blog.spheron.network/migration-to-the-new-phase-the-road-ahead-for-fizz-and-provider-nodes"
                        );
                      }}
                      rightIcon={<Arrow className="w-5 h-5" />}
                    />
                  </div>
                }
                type={"info"}
              /> */}
              <Navbar />
              <BreadcrumbsContainer />
            </nav>
            <main>{children}</main>
            <footer className="mt-[100px]">
              <OnlyClient>
                <Footer />
              </OnlyClient>
            </footer>
          </ThemeWrapper>
        </ThemeProvider>
      </ThirdwebProvider>
    </>
  );
}
